import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Button } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import Stats from '../containers/Stats/Stats';
import UsersTable from '../containers/UsersTable/UsersTable';
import ReportsTable from '../containers/ReportsTable/ReportsTable';

const styles = theme => ({
  baseTop: {
    marginTop: theme.spacing.unit,
  },
  container: {
    marginTop: theme.spacing.unit * 5,
  },
  titleRow: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-between',
  },
  manageBtn: {
    color: theme.palette.primary.main,
    backgroundColor: grey[50],
    '&:hover': {
      backgroundColor: grey[200],
    },
  },
});

const propTypes = {
  classes: PropTypes.oneOfType([PropTypes.object]).isRequired,
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
};


const Dashboard = ({ classes, history }) => (
  <div className={classes.baseTop}>
    <Stats />
    <div className={classes.container}>
      <div className={classes.titleRow}>
        <Typography variant="headline">
          New Users
        </Typography>
        <Button
          variant="contained"
          color="primary"
          className={classes.manageBtn}
          onClick={() => history.push('/users')}
        >
          Manage
        </Button>
      </div>
      <UsersTable history={history} defaultLimit={10} showEmptyRows />
    </div>
    <div className={classes.container}>
      <div className={classes.titleRow}>
        <Typography variant="headline">
          Last Uploaded Reports
        </Typography>
        <Button
          variant="contained"
          color="primary"
          className={classes.manageBtn}
          onClick={() => history.push('/reports')}
        >
          Manage
        </Button>
      </div>
      <ReportsTable defaultLimit={10} showEmptyRows />
    </div>
  </div>
);

Dashboard.propTypes = propTypes;
export default withStyles(styles)(Dashboard);



// WEBPACK FOOTER //
// ./src/pages/Dashboard.js